var app = angular.module('directives.paymentConfirm');

app.directive('paymentConfirm', [
    'configs',
    '$state',
    '$rootScope',
    'ClientCards',
    function(configs, $state, $rootScope, ClientCards) {
        var tmplUrl;

        try {
            tmplUrl = require('../templates/'+$state.current.name.replace('pages.','')+'.html');//looking for template with moduleName
        }catch(e){
            tmplUrl = require('../templates/index.html')//if error(no such file), use default template
        }

        var parsedLink = $state.current.url.split("/");
        parsedLink.forEach(function(key) {
            if (key == 'l') {
                tmplUrl = require('../templates/index.html');
            }
            if (key == 'ls') {
                tmplUrl = require('../templates/service.html');
            }
        });

        return {
            template: tmplUrl,
            controller:'confirmCtrl',
            link: function(scope, element, attrs, ctrl) {
            }
        }

    }
]);

app.controller('confirmCtrl',function ($scope, Pay, ClientCards) {
    $scope.pay = Pay;
    
    if (!$scope.form) {
        $scope.form = {};
    }
    
    $scope.showAgreementError = false;
    
    $scope.checkAgreement = function() {
        if (!$scope.form.finance_agreement) {
            $scope.showAgreementError = true;
            return false;
        }
        $scope.showAgreementError = false;
        return true;
    };
    
    $scope.checkAgreementOnSubmit = function(event) {
        if (!$scope.form.finance_agreement) {
            event.preventDefault();
            $scope.showAgreementError = true;
            return false;
        }
        $scope.showAgreementError = false;
        return true;
    };
    
    $scope.$watch('form.finance_agreement', function(newVal) {
        if (newVal && $scope.showAgreementError) {
            $scope.showAgreementError = false;
        }
    });
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentConfirm/directives/paymentConfirm.js
 ** module id = 196
 ** module chunks = 1
 **/